import { Box } from "@mui/material";
import "../../styles/scss/Loader.scss";

export default function Loader() {
  return (
    <Box className="loader-container">
      <Box className="loader">
        <Box className="spinner"></Box>
        <Box className="inner">
          <Box className="spinner-inner"></Box>
        </Box>
      </Box>
    </Box>
  );
}
